import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  TextField,
  DialogActions,
  TablePagination,
  Typography,
  ThemeProvider,
  createTheme,
  Box,
  Chip,
  Autocomplete,
  InputAdornment,
  IconButton,
  InputBase,
  Divider,
  Popover,
  useMediaQuery,
} from '@mui/material';
import OpenInBrowser from '@mui/icons-material/OpenInBrowser';
import KeyboardDoubleArrowRightOutlined from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import {
  Add,
  Close,
  Delete,
  DeleteOutline,
  DoNotDisturbAlt,
  Edit,
  GroupAdd,
  Search,
  StopCircle,
  Warning,
} from '@mui/icons-material';
// import './publisher-list.styles.scss';
import { TransitionProps } from '@mui/material/transitions';
import apiClient from '@lift-admin/utils/apiClient';
import { debounce } from '@lift-admin/utils/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { Info } from 'lucide-react';
import {
  buildDetails,
  buildSummary,
  diffFields,
  type FieldSpec,
} from '@lift-admin/utils/logChangeFormatter';


import { DataGrid, GridEditSingleSelectCell } from '@mui/x-data-grid';



import { Tooltip } from '@lift-admin/ui/tooltip';
import { Toastify } from 'lift-ui';
import { makeStyles } from '@mui/styles';
import { IconLayoutGridAdd, IconX } from '@tabler/icons-react';
import { actionLog } from '../../../App';

const UI_COMPONENT_FIELD_SPECS: FieldSpec[] = [
  { key: 'name', label: 'Name' },
  { key: 'description', label: 'Description' },
];

// import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
    secondary: {
      main: 'rgba(0, 0, 0, 0)',
    },
  },
  typography: {
    fontFamily: '"Figtree", sans-serif',
  },
});
const useStyles = makeStyles({
  blockedRow: {
    backgroundColor: '#ffd8c7',
  },
});
interface ItemsProps {
  toggle: string;
  searchText: string;
  // channelsBody: { name: string; description: string };
  // setChannelsBody: (ui-component: { name: string; description: string }) => void;
  openDialog: boolean;
  setOpenDialog: (value: boolean) => void;
}

const UIComponents = ({
  toggle,
  searchText,
  // channelsBody,
  // setChannelsBody,
  openDialog,
  setOpenDialog,
}: ItemsProps) => {
  const [loadData, setLoadData] = useState<boolean>(false);
  const [drawerItem, setDrawerItems] = useState<any>([]);
  const [drawerItemBackUp, setDrawerItemsBackup] = useState<any>([]);
  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);

  const [currentId, setCurrentId] = useState(null);
  const [name, setName] = useState<string | null>();
  const [description, setDescription] = useState<string | null>();
  // Snapshot of the row being edited, used to log before -> after changes.
  const editOriginalRef = useRef<{ name?: string; description?: string }>({});

  const getCustomComponents = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/ui-components'
      );

      const uiComponents = res?.data?.response?.uiComponents.sort(
        (
          a: { created_at: string | number | Date },
          b: { created_at: string | number | Date }
        ) => {
          // Assuming created_at is in ISO 8601 format (e.g., "2024-12-17T14:52:29.000Z")
          return (
            (new Date(b.created_at) as any) - (new Date(a.created_at) as any)
          );
        }
      );
      setDrawerItems(uiComponents);
      setDrawerItemsBackup(uiComponents);
    } catch {
      Toastify('error', 'Verticals not fetched');
    } finally {
      setLoadData(false);
    }
  };
  useEffect(() => {
    getCustomComponents();
  }, []);
  const rowData = useMemo(() => drawerItem, [drawerItem]);

  const columnDefs = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'Name',
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: 'flex', alignItems: 'center' },
      },
      {
        field: 'description',
        headerName: 'Description',
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: 'flex', alignItems: 'center' },
      },
      {
        field: 'created_at',
        headerName: 'Created At',
        width: 200,
        sortable: true,
        resizable: true,
        editable: false,
        flex: 1,
        cellStyle: { display: 'flex', alignItems: 'center' },
        valueFormatter: (params: { value: string }) => {
          if (!params.value) return '';
          const date = new Date(params.value);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        },
      },
      {
        field: 'updated_at',
        headerName: 'Updated At',
        width: 200,
        sortable: true,
        resizable: true,
        editable: false,
        flex: 1,
        cellStyle: { display: 'flex', alignItems: 'center' },
        valueFormatter: (params: { value: string }) => {
          if (!params.value) return '';
          const date = new Date(params.value);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        },
      },
    ],
    []
  );

  const defaultColDef = {
    resizable: true,
    sortable: true,
    editable: false, // Can be overridden per column
  };
  // const rowData = drawerStructure; // Assuming `paginatedList` is your data array

  const onCellValueChanged = (params: { data: any }) => {
    console.log('Data after change:', params.data);
    // Handle updated data (e.g., update your state or call an API)
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setName('');
    setDescription('');
  };

  const resolveComponentName = (id: any) =>
    drawerItemBackUp?.find((c: any) => String(c.id) === String(id))?.name ||
    name ||
    undefined;

  const handleAddChannel = async () => {
    try {
      if (!name || name.length == 0) {
        Toastify('error', 'Please enter correct fields');
        return;
      }

      const payload = {
        name: name,
        description: description,
      };
      const res = await apiClient.post(
        '/drawer/v1/admin/drawer/structure/ui-component',
        payload
      );
      getCustomComponents();
      setName('');
      setDescription('');
      setOpenDialog(false);

      const user = JSON.parse(localStorage.getItem('user') || '{}');
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: buildSummary('UI component', name, 'created'),
          status: res.status,
          method: res.config?.method,
          url: res.config?.url,
          category: 'drawer',
          action: 'create_ui_component',
          ui_component_id: res?.data?.id ?? res?.data?.response?.id,
          ui_component_name: name,
          user_id: user?.id,
          user_name: user?.name,
          details: buildDetails(payload, UI_COMPONENT_FIELD_SPECS, {
            skipEmpty: true,
          }),
        }),
        false
      );
    } catch (err: any) {
      setOpenDialog(false);
      Toastify('error', 'Custom Component not added');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: `Failed to create UI component "${name}"`,
          status: err?.response?.status || 500,
          method: 'POST',
          url: '/drawer/v1/admin/drawer/structure/ui-component',
          category: 'drawer',
          action: 'create_ui_component',
          ui_component_name: name,
          user_id: user?.id,
          user_name: user?.name,
        }),
        true
      );
    }
  };
  const handleDelete = async (id: any) => {
    const componentName = resolveComponentName(id);
    try {
      if (!id || isNaN(id)) {
        Toastify(
          'error',
          'Invalid UI Component ID. Please select correct channel'
        );
        return;
      }
      const res = await apiClient.delete(
        `/drawer/v1/admin/drawer/structure/ui-component/${id}`
      );

      getCustomComponents();
      Toastify('success', 'Item Deleted successfully');

      const user = JSON.parse(localStorage.getItem('user') || '{}');
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: buildSummary('UI component', componentName, 'deleted'),
          status: res.status,
          method: res.config?.method,
          url: res.config?.url,
          category: 'drawer',
          action: 'delete_ui_component',
          ui_component_id: id,
          ui_component_name: componentName,
          user_id: user?.id,
          user_name: user?.name,
          details: [
            { label: 'UI Component ID', value: String(id) },
            ...(componentName
              ? [{ label: 'Name', value: String(componentName) }]
              : []),
          ],
        }),
        false
      );
    } catch (err: any) {
      Toastify('error', 'Custom Component not deleted');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: `Failed to delete UI component "${componentName || id}"`,
          status: err?.response?.status || 500,
          method: 'DELETE',
          url: `/drawer/v1/admin/drawer/structure/ui-component/${id}`,
          category: 'drawer',
          action: 'delete_ui_component',
          ui_component_id: id,
          ui_component_name: componentName,
          user_id: user?.id,
          user_name: user?.name,
        }),
        true
      );
    }
  };

  const handleEdit = async () => {
    if (!currentId || isNaN(currentId)) {
      Toastify(
        'error',
        'Invalid Ui Component ID. Please select correct UI Component'
      );
      return;
    }

    if (!name || name.length == 0) {
      Toastify('error', 'Please enter correct fields');
      return;
    }
    try {
      const nextData = {
        name: name,
        description: description,
      };
      const res = await apiClient.put(
        `/drawer/v1/admin/drawer/structure/ui-component/${currentId}`,
        nextData
      );
      const original = editOriginalRef.current || {};
      const changes = diffFields(original, nextData, UI_COMPONENT_FIELD_SPECS);

      Toastify('success', 'Item updated successfully');
      getCustomComponents();
      handleEditDialogClose();
      setName('');
      setDescription('');

      const user = JSON.parse(localStorage.getItem('user') || '{}');
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: buildSummary(
            'UI component',
            name || original.name,
            'updated',
            changes.length
          ),
          status: res.status,
          method: res.config?.method,
          url: res.config?.url,
          category: 'drawer',
          action: 'update_ui_component',
          ui_component_id: currentId,
          ui_component_name: name || original.name,
          user_id: user?.id,
          user_name: user?.name,
          changes,
        }),
        false
      );
    } catch (err: any) {
      Toastify('error', 'Item not updated');
      console.error(err);
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      await actionLog?.actionLogTrack(
        JSON.stringify({
          message: `Failed to update UI component "${name || editOriginalRef.current?.name || currentId}"`,
          status: err?.response?.status || 500,
          method: 'PUT',
          url: `/drawer/v1/admin/drawer/structure/ui-component/${currentId}`,
          category: 'drawer',
          action: 'update_ui_component',
          ui_component_id: currentId,
          ui_component_name: name || editOriginalRef.current?.name,
          user_id: user?.id,
          user_name: user?.name,
        }),
        true
      );
    }
  };

  const handleSubmit = () => {
    // setChannelsBody({ name, description });

    handleAddChannel();
  };
  const handleEditOpen = (data: any) => {
    setCurrentId(data?.id);
    setName(data?.name);
    setDescription(data?.description);
    editOriginalRef.current = { name: data?.name, description: data?.description };
    setOpenEditDialog(true);
  };
  const handleEditDialogClose = () => {
    setOpenDialog(false);
    setName(null);
    setDescription(null);
    setCurrentId(null);
    setOpenEditDialog(false);
  };

  const searchResults = (query: any) => {
    const filteredUsers = [...drawerItemBackUp];
    let results = [];
    for (let i = 0; i < filteredUsers.length; i++) {
      if (filteredUsers[i]['name']?.toLowerCase().includes(query.toLowerCase()))
        results.push(filteredUsers[i]);
    }

    setDrawerItems(results);
  };

  useEffect(() => {
    searchResults(searchText);
  }, [searchText]);
  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="info-container">
          <Info className="info-icon" />
          <p
            style={{
              marginLeft: '0.5rem',
            }}>
            Please create a{" "}
            <a href="https://feedback.lift.newengen.com/" target="_blank" rel="noopener noreferrer" className="text-blue-500 underline hover:no-underline">ticket</a>
            {" "}for any additions or modifications
          </p>
        </div>
        <Paper className="table-paper-with-info" style={{ paddingLeft: 0 }}>
          <div
            className="ag-theme-alpine"
            style={{ height: '100%', width: '100%' }}>
            <AgGridReact
              columnDefs={columnDefs.map((colDef) => ({
                ...colDef,
                editable: false,
              }))}
              rowData={rowData}
              defaultColDef={defaultColDef}
              rowHeight={80}
              pagination={true}
              paginationPageSize={20}
              suppressPaginationPanel={false}
            />
          </div>
        </Paper>
      </ThemeProvider>
    </>
  );
};

export default UIComponents;
